import React, { useState } from 'react'
import { Drawer, Flex, Input, Button } from 'antd'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'
import { endpoints } from 'modules/endpoints'
import { Progress } from 'modules/types'
import useDownload from 'hooks/useDownload'
import type { SeedInventory } from '../SeedInventoryTable'
import SeedInventoryOrdersList from './SeedInventoryOrdersList'
import { drawerRowStyle, FullWidthCard, scrollAreaStyle } from '../../styles'

type SeedInventoryOrdersTabProps = {
  record?: SeedInventory | null
}

const SeedInventoryOrdersTab: React.FC<SeedInventoryOrdersTabProps> = ({ record }) => {
  const { t } = useTranslation(['seedTracker', 'labels'])
  const { id } = useParams<{ id: string }>()
  const [search, setSearch] = useState<string | undefined>(undefined)
  const [filtersDrawerOpen, setFiltersDrawerOpen] = useState(false)
  const { Search } = Input
  const [progressCSV, downloadCSV] = useDownload(endpoints.seedOrders('download/csv'), {
    ...(id ? { product_card_id: id } : {}),
    ...(record?.companyId ? { origin_company_id: record.companyId } : {}),
    ...(record?.seededPedigree ? { current_pedigree: record.seededPedigree } : {}),
  })

  const downloadButton = (
    <Button
      type="default"
      onClick={downloadCSV}
      loading={progressCSV === Progress.WORK}
      disabled={!id || !record?.companyId || !record?.seededPedigree}
    >
      {t('labels:downloadCsv')}
    </Button>
  )

  return (
    <Flex vertical style={drawerRowStyle}>
      <FullWidthCard title={t('seedTracker:detail.tabs.orders', 'Orders')} variant="borderless" extra={downloadButton}>
        <Flex vertical>
          <div style={scrollAreaStyle}>
            <SeedInventoryOrdersList
              seedInventoryId={id}
              productCardId={id}
              originCompanyId={record?.companyId}
              seededPedigree={record?.seededPedigree}
              search={search}
            />
          </div>
          <Drawer
            title={t('seedTracker:detail.seedInventory.filtersDrawerTitle')}
            placement="right"
            open={filtersDrawerOpen}
            onClose={() => setFiltersDrawerOpen(false)}
            width={378}
            destroyOnClose={false}
          >
            <Flex vertical gap="middle">
              <Search
                placeholder={t('seedTracker:list.searchPlaceholder')}
                onSearch={(value) => setSearch(value || undefined)}
                value={search ?? ''}
                allowClear
                onChange={(e) => setSearch(e.target.value || undefined)}
              />
            </Flex>
          </Drawer>
        </Flex>
      </FullWidthCard>
    </Flex>
  )
}

export default SeedInventoryOrdersTab
